module.exports = __webpack_public_path__ + "624c1255/img/team.68b3d85e.png";